import { useTranslation } from 'react-i18next';

import {
    Body1,
    Box,
    Modal,
    Stack,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';
import { constants } from '@myphx-engineering/phx-design-system/framework';

export type SmartpriceCardInfoModalProps = {
    isOpen: boolean;
    close: () => void;
};

export const SmartpriceCardInfoModal = ({
    isOpen,
    close,
}: SmartpriceCardInfoModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            opened={isOpen}
            onClose={close}
            title={t('planCards.smartprice.modal.title', {
                tm: constants.unicode.TRADEMARK,
            })}
        >
            <Stack gap="sm">
                <Box>
                    <Subtitle2>
                        {t('planCards.smartprice.modal.whatIsIt.heading', {
                            tm: constants.unicode.TRADEMARK,
                        })}
                    </Subtitle2>
                    <Body1>
                        {t('planCards.smartprice.modal.whatIsIt.body')}
                    </Body1>
                </Box>
                <Box>
                    <Subtitle2>
                        {t('planCards.smartprice.modal.deductible.heading', {
                            tm: constants.unicode.TRADEMARK,
                        })}
                    </Subtitle2>
                    <Body1>
                        {t('planCards.smartprice.modal.deductible.body')}
                    </Body1>
                </Box>
            </Stack>
        </Modal>
    );
};
